import React from "react";
import zelle from "../assets/zelle.png";
import "./style.css";

export default function Footer() {
    return (
        <div className="footer">
            Designed & Managed by 
            <a 
                href="https://www.zellesolutions.com" // Replace with the actual website URL
                target="_blank" 
                rel="noopener noreferrer"
                style={{ fontWeight: "bold", marginLeft: "5px", textDecoration: "none", color: "inherit" }}
            > 
                Zelle Solutions Pvt. Ltd
            </a>
        </div>
    );
}
